import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class SquawksAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/squawks";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getById(id, router) {
    const url = `/api/squawks/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getStatuses(router) {
    const url = "/api/squawks/statuses";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByAircraftId(aircraftId, router) {
    const url = `/api/squawks/aircraft/${aircraftId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(formData) {
    const url = "/api/squawks";
    return this.CommonAPIService.postCall(url, formData);
  }

  delete(id, router) {
    const url = `/api/squawks/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(id, formData) {
    const url = `/api/squawks/${id}`;
    return this.CommonAPIService.putCall(url, formData);
  }
}
export default SquawksAPIService;
